import { CSSProperties, PropsWithChildren, useEffect } from 'react';

import styles from './layout-grid.module.css';
import { useAppSelector } from '@/store/hooks';
import { selectPreviewSize } from '@/store/slices/layout-grid/selectors';

type MainProps = PropsWithChildren<{
  width?: CSSProperties['width'];
  minWidth?: string;
  backgroundColor?: CSSProperties['backgroundColor'];
}>;

const Main = ({ backgroundColor, children, width, minWidth }: MainProps) => {
  const previewSize = useAppSelector(selectPreviewSize);

  useEffect(() => {
    if (minWidth !== undefined) {
      document.documentElement.style.setProperty('--layout-grid-main-section-min-width', minWidth);
    } else {
      document.documentElement.style.setProperty(
        '--layout-grid-main-section-min-width',
        'calc(var(--main-width-starting-point) - var(--layout-grid-pillar-width) - var(--layout-grid-panel-width))'
      );
    }

    return () => {
      document.documentElement.style.setProperty(
        '--layout-grid-main-section-min-width',
        'calc(var(--main-width-starting-point) - var(--layout-grid-pillar-width) - var(--layout-grid-panel-width))'
      );
    };
  }, [minWidth]);

  return (
    <main
      className={`${styles.main} ${styles[previewSize] || ''}`}
      style={{
        ...(width ? { width } : {}),
        ...(backgroundColor ? { backgroundColor } : {}),
      }}
    >
      {children}
    </main>
  );
};

export default Main;
